import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { LogIn, ArrowLeft } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { COMPANY } from '@/lib/data';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function AdminLoginPage() {
    const { login, user } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/admin/dashboard';

    useEffect(() => {
        if (user) navigate(from, { replace: true });
    }, [user, navigate, from]);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            toast.error('Ingresa email y contraseña.');
            return;
        }
        setSubmitting(true);
        try {
            await login(email, password);
            toast.success('Bienvenido');
            navigate(from, { replace: true });
        } catch (err) {
            const detail = err?.response?.data?.detail || 'Credenciales inválidas';
            toast.error(detail);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4 py-10">
            <div className="w-full max-w-md">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-4"><ArrowLeft className="size-4" /> Volver al sitio</Link>
                <form data-testid="admin-login-form" onSubmit={onSubmit} className="rounded-2xl border border-border bg-white shadow-[var(--shadow-soft)] p-6 sm:p-8">
                    <div className="flex items-center justify-start"><img src={COMPANY.logo} alt={COMPANY.name} className="h-24 w-24 object-contain" /></div>
                    <h1 className="mt-5 text-2xl font-display font-bold">Acceso Administrador</h1>
                    <p className="mt-1 text-sm text-muted-foreground">Solo personal autorizado.</p>
                    <div className="mt-6 space-y-4">
                        <div>
                            <Label htmlFor="al-email">Email</Label>
                            <Input id="al-email" data-testid="admin-login-email-input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" placeholder="correo@ejemplo.com" />
                        </div>
                        <div>
                            <Label htmlFor="al-pass">Contraseña</Label>
                            <Input id="al-pass" data-testid="admin-login-password-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" placeholder="••••••••" />
                        </div>
                        <button type="submit" disabled={submitting} data-testid="admin-login-submit-button" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground font-semibold px-4 py-2.5 text-sm hover:brightness-105 disabled:opacity-60">
                            <LogIn className="size-4" /> {submitting ? 'Ingresando…' : 'Ingresar'}
                        </button>
                    </div>
                </form>
                <p className="mt-3 text-center text-xs text-muted-foreground">Las credenciales se configuran vía variables de entorno.</p>
            </div>
        </div>
    );
}
